exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".style[data-v-f4390cb2]{background:#fff;width:100%}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/pages/styleguide/index.vue"],"names":[],"mappings":"AACA,wBACE,gBAAiB,AACjB,UAAY,CACb","file":"index.vue","sourcesContent":["\n.style[data-v-f4390cb2] {\n  background: #fff;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4390cb2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/styleguide/index.vue
// module id = 1217
// module chunks = 3